import { Language } from '@ha/intl';

// slug for each language
export const PrivateLandlordPageSlugLanguageMap = {
  [Language.it]: 'affitto-da-privati',
};
